export const logPolygonCoordinates = (polygon: google.maps.Polygon) => {
  const path = polygon.getPath()
  const coordinates = []

  for (let i = 0; i < path.getLength(); i++) {
    const latLng = path.getAt(i)
    coordinates.push({ lat: latLng.lat(), lng: latLng.lng() })
  }

  return coordinates
}

export function toCoordinates(geojson: { coordinates: number[][][] }) {
  return geojson.coordinates[0].map((c) => ({ lng: c[0], lat: c[1] }))
}
